import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { IconButton } from "../Button/IconButton";
import { Input } from "./Input";
import type { IInputColor, IInputPasswordProps, IInputSize } from "./types";
import { textFieldButtonColor, textFieldButtonSize } from "../../utils";
import { useMediaQuery } from "../../hooks/useMediaQuery";

export const InputPassword = (props: IInputPasswordProps) => {
  const isMobile = useMediaQuery("(max-width: 639px)");
  const size: IInputSize = props.size || (isMobile ? "lg" : "md");
  const color: IInputColor = props.color || "layer1";
  const [visible, setVisible] = useState<boolean>(false);

  const onChangeType = () => {
    setVisible((visible: boolean) => !visible);
  };

  return (
    <Input
      {...props}
      autoComplete={props.autoComplete || "off"}
      placeholder={props.placeholder || "Password"}
      type={visible ? "text" : "password"}
      endAccessory={
        <IconButton
          size={textFieldButtonSize[size]}
          color={textFieldButtonColor[color]}
          onClick={onChangeType}
          content={visible ? <EyeOff /> : <Eye />}
        />
      }
    />
  );
};
